'use strict';
import noop from 'lodash/noop';
import {FormsEditHeader} from './components/views/FormsEditHeader';
import {FormsListHeader} from './components/views/FormsListHeader';
import {FormListController} from './controllers/FormListController';
import {FormListFilterService} from './filters/FormListFilter';
import {routerConfig} from './router';
import {FormSelectorFilterMixin} from './selector/FormSelectorFilterMixin';
import {FormUtils} from './services/FormUtils';

/**
 * Module dependencies
 */
const angular = require('angular');

// Components
// - Builder
const FormBuilderDirective = require('./directives/builder/FormBuilderDirective.js');
const FormFieldBuilderDirective = require('./directives/fields/FormFieldBuilderDirective.js');
const FormFieldBuilderEditInternalDirective = require('./directives/FormFieldBuilderEditInternalDirective.js');
const FormFieldPreviewDirective = require('./directives/FormFieldPreviewDirective.js');
const FormOptionDirective = require('./directives/options/FormOptionDirective.js');
const FormOptionsDirective = require('./directives/options/FormOptionsDirective.js');

// - Response
const FormResponseDirective = require('./directives/response/FormResponseDirective.js');
const FormFieldResponseDirective = require('./directives/FormFieldResponseDirective.js');
const FormItemDirective = require('./directives/item/FormItemDirective.js');

module.exports = angular
  .module('app.forms', [])
  .config(routerConfig)
  .constant('FORM_SAVE_RESULT', require('./FORM_SAVE_RESULT.js'))

  /* Domain Classes */
  .provider('FormDomain', require('./domain/FormDomain.js'))
  .run(['FormDomain', noop])
  .provider('FormInstanceDomain', require('./domain/FormInstanceDomain.js'))
  .provider('FormResponseDomain', require('./domain/FormResponseDomain.js'))

  /* Services */
  .service('FormListFilter', FormListFilterService)
  .service('FormUtils', FormUtils)

  /* Components */
  .directive('formBuilder', FormBuilderDirective.directive)
  .controller('FormBuilderController', FormBuilderDirective.controller)

  .directive('formFieldBuilder', FormFieldBuilderDirective.directive)
  .controller('FormFieldBuilderController', FormFieldBuilderDirective.controller)
  .run(FormFieldBuilderDirective.templates)

  .directive('formFieldBuilderEditInternal', FormFieldBuilderEditInternalDirective.directive)
  .controller('FormFieldBuilderInternalController', FormFieldBuilderEditInternalDirective.controller)
  .run(FormFieldBuilderEditInternalDirective.templates)

  .directive('formFieldPreview', FormFieldPreviewDirective.directive)
  .run(FormFieldPreviewDirective.templates)

  .directive('formOption', FormOptionDirective.directive)
  .controller('FormOptionController', FormOptionDirective.controller)
  .run(FormOptionDirective.templates)

  .directive('formOptions', FormOptionsDirective.directive)
  .controller('FormOptionsController', FormOptionsDirective.controller)

  .directive('formResponse', FormResponseDirective.directive)
  .controller('FormResponseController', FormResponseDirective.controller)

  .directive('formFieldResponse', FormFieldResponseDirective.directive)
  .controller('FormFieldResponseController', FormFieldResponseDirective.controller)
  .run(FormFieldResponseDirective.templates)

  .directive('formItem', FormItemDirective.directive)
  .controller('FormItemController', FormItemDirective.controller)

  /* Selectors */
  .service('FormSelectorFilterMixin', FormSelectorFilterMixin)
  .component('formSelect', require('./selector/FormSelectorItem.js'))
  .controller('FormSelectorPanelController', require('./selector/FormSelectorPanelController.js'))

  /* Views */
  .controller('FormListController', FormListController)
  .directive('formsListHeader', ['reactDirective', reactDirective => reactDirective(FormsListHeader)])
  .directive('formsEditHeader', ['reactDirective', reactDirective => reactDirective(FormsEditHeader)])
  .controller('FormCreateController', require('./controllers/FormCreateController.js'));



// WEBPACK FOOTER //
// ./src/js/forms/index.js